@if(type() === 'richtext') {
  <div #textContainer [class.truncate-text-three-lines]="!isExpanded()" [innerHTML]="innerHTML()" [class]="richtextClassName()" [attr.data-richtext]="'true'" appTranslate></div>
  @if(showReadMore() && !isExpanded()) {
    <span class="cursor-pointer text-decoration-none fs-default {{ fontColor() ?? 'text-muted' }}" (click)="expand()">{{'SEEMORETEXT' | translate}}</span>
  }
} @else {
  <span class="{{ fontSize() ?? 'fs-5' }} {{ fontColor() }} {{ fontDecoration() }} {{ cssClass() }}" appTranslate><ng-content></ng-content></span>
}
